import * as plansActions from '../../../InsuranceForm/plans';
import { carrierSelector } from '../carrier';

export function fetchPlansIfNeeded() {
    return (dispatch, getState) => {
        const state = getState();
        const carrierId = carrierSelector(state);
        return plansActions.fetchPlansIfNeeded(carrierId)(dispatch, getState);
    };
}
